import apiUrl from "../apiURL";
import axiosInstance from "../axiosInstance";
import { getAuthHeaders } from "../cart";


export const getSeoData = async (pathname) => {
    try {
        // Get the Authorization headers
        const headers = getAuthHeaders();

        // Pass headers as part of the options object
        const response = await axiosInstance.get(apiUrl.common.getAllMeta, { headers });
        if (response.status === 200) {
            // console.log('seo fetched successfully', pathname, response.data);
            // Filter the SEO data for the specific pathname
            const seoData = response.data.find(item => item.pageSlug === pathname);
            return seoData || {};
        }
    } catch (error) {
        console.error("Error fetching cart:", error);
    }
}